import { I as Icon, _ as _extends } from './Icon-BnBRpux5.js';
import React, { forwardRef } from 'react';
import '@emotion/is-prop-valid';
import '@indeed/ifl-css';
import '@emotion/react';
import './IconProvider.js';

const Plus = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    fill = "currentColor",
    size = "md",
    variant,
    ...remainingProps
  } = _ref;
  const paths = {
    filled: /*#__PURE__*/React.createElement("path", {
      d: "M10.8624 13.1376H5.9341c-.3191 0-.5885-.1097-.8082-.3292-.2195-.2197-.3293-.4891-.3293-.8083 0-.3191.1098-.5886.3293-.8082.2197-.2195.489-.3293.8082-.3293h4.9283V5.9344c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v4.9282h4.9282c.3192 0 .5886.1098.8083.3293.2195.2196.3292.4891.3292.8082 0 .3192-.1097.5886-.3292.8083-.2197.2195-.4891.3292-.8083.3292h-4.9282v4.9283c0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293-.3192 0-.5886-.1098-.8083-.3293-.2195-.2196-.3292-.4891-.3292-.8082v-4.9283z"
    }),
    stroke: /*#__PURE__*/React.createElement("path", {
      d: "M10.8624 13.1376H5.9341c-.3191 0-.5885-.1097-.8082-.3292-.2195-.2197-.3293-.4891-.3293-.8083 0-.3191.1098-.5886.3293-.8082.2197-.2195.489-.3293.8082-.3293h4.9283V5.9344c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v4.9282h4.9282c.3192 0 .5886.1098.8083.3293.2195.2196.3292.4891.3292.8082 0 .3192-.1097.5886-.3292.8083-.2197.2195-.4891.3292-.8083.3292h-4.9282v4.9283c0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293-.3192 0-.5886-.1098-.8083-.3293-.2195-.2196-.3292-.4891-.3292-.8082v-4.9283z"
    }),
    strokertl: /*#__PURE__*/React.createElement("path", {
      d: "M10.8624 13.1376H5.9341c-.3191 0-.5885-.1097-.8082-.3292-.2195-.2197-.3293-.4891-.3293-.8083 0-.3191.1098-.5886.3293-.8082.2197-.2195.489-.3293.8082-.3293h4.9283V5.9344c0-.3192.1097-.5886.3292-.8083.2197-.2195.4891-.3292.8083-.3292.3191 0 .5886.1097.8082.3292.2195.2197.3293.4891.3293.8083v4.9282h4.9282c.3192 0 .5886.1098.8083.3293.2195.2196.3292.4891.3292.8082 0 .3192-.1097.5886-.3292.8083-.2197.2195-.4891.3292-.8083.3292h-4.9282v4.9283c0 .3191-.1098.5886-.3293.8082-.2196.2195-.4891.3293-.8082.3293-.3192 0-.5886-.1098-.8083-.3293-.2195-.2196-.3292-.4891-.3292-.8082v-4.9283z"
    })
  };
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref,
    fill: fill,
    paths: paths,
    size: size,
    variant: variant
  }, remainingProps));
});
Plus.displayName = "PlusIcon";

export { Plus, Plus as default };
